
exports = module.exports = trim;

function trim(str){
  return str.replace(/^\s*|\s*$/g, '');
}

exports.left = function(str){
  return str.replace(/^\s*/, '');
};

exports.right = function(str){
  return str.replace(/\s*$/, '');
};



// WEBPACK FOOTER //
// /Users/jinxuanzhu/.nvm/versions/node/v8.4.0/lib/node_modules/remark-parse/node_modules/trim/index.js